import React, { useState, useEffect } from "react";
import axios from "axios";
import { Button, Input, Modal, Table, message } from "antd";
import { FiPlusCircle } from "react-icons/fi";
import { toast , Toaster} from "sonner";

const Wallet = () => {
  const user = JSON.parse(localStorage.getItem("user"));
  console.log("user , ", user)
  const token = localStorage.getItem("token");
  const userId = user.userId // Replace with actual user ID from auth
  // const userId2 = "65dcb29a7e3b3c001d9fd4e2"; // Replace with actual user ID from auth
  // console.log(userId  , "user id")
  const [balance, setBalance] = useState(0);
  const [transactions, setTransactions] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [topUpAmount, setTopUpAmount] = useState("");

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  }, []);

  // Fetch transaction history from backend
  useEffect(() => {
    if (token){
      const fetchTransactions = async () => {
        try {
          const res = await axios.get(`https://wavetechservices.in/api/user/wallet/topup/${userId}`);
          setBalance(res.data.balance);
          // console.log(res.data);
          setTransactions(res.data.transactions);
        } catch (error) {
          console.error("Error : " , error)
          message.error("Failed to load transaction history");
        }
      };
  
      if (userId) fetchTransactions();
    } else{
      toast.error("Please login")
    }
  }, []);

  // Handle top-up transaction
  const handleTopUp = async () => {
    const amount = parseFloat(topUpAmount);
    if (isNaN(amount) || amount <= 0) {
      message.error("Please enter a valid amount");
      return;
    }

    if (token) {
      const config = {
       url:"/api/user/wallet/transactions",
        method:"post",
        baseURL:"https://wavetechservices.in",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        data: {
            userId ,
          amount,
          type: "Credit",
        }
      }

      const configPayment={
        url:"/api/phonepay/addpaymentphonepay",
        method:"post",
        baseURL:"https://wavetechservices.in",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        data: {
           userId: user.userId,
            amount: amount,
            username: user.name,
            orderId: "WAVE" + new Date(),
            Mobile: user.phone,
            config: JSON.stringify(config),
            failedUrl: "/wallet",
            successUrl: "/wallet"
        },
      }


      try {
        const res = await axios(configPayment);
        if(res.status === 200){
        setTopUpAmount("");
         return window.location.href = res.data?.url?.url
        }
      } catch (error) {
        // console.log("Error :" , error)
        message.error("Transaction failed");
      }
    } else{
      toast.error("Please Login")
      return
      // alert("Please Login")
    }
  };

  const handleAmountChange = (e) => {
    const value = e.target.value;
    if (/^\d*\.?\d*$/.test(value)) {
      setTopUpAmount(value);
    }
  };

  const columns = [
    { title: "Transaction ID", dataIndex: "transactionId", key: "transactionId" },
    { title: "Amount", dataIndex: "amount", key: "amount", render: (amount) => `₹${amount}` },
    { title: "Type", dataIndex: "type", key: "type" },
    { title: "Date", dataIndex: "date", key: "date", render: (date) => new Date(date).toLocaleDateString() },
  ];

  return (
    <div className="min-h-screen p-6 bg-gray-100 flex flex-col items-center">
      <Toaster/>
      <div className="bg-white shadow-lg rounded-lg p-6 mt-40 w-full max-w-2xl text-center">
        <h2 className="text-2xl font-semibold">Your Wallet</h2>
        <p className="text-gray-600 text-lg mt-2">
          Balance: <span className="text-green-500 font-bold">₹{balance}</span>
        </p>
        <Button
          className="mt-4 bg-blue-500 text-white px-4 py-2 rounded flex items-center mx-auto"
          onClick={() => setIsModalOpen(true)}
        >
          <FiPlusCircle className="mr-2" /> Top Up
        </Button>
      </div>

      <div className="bg-white shadow-lg rounded-lg p-6 w-full max-w-3xl mt-6">
        <h3 className="text-xl font-semibold mb-4">Transaction History</h3>
        <Table columns={columns} dataSource={transactions} rowKey="transactionId" pagination={false} />
      </div>

      <Modal title="Top Up Wallet" open={isModalOpen} onCancel={() => setIsModalOpen(false)} footer={null} centered>
        <div className="flex flex-col items-center p-4">
          <Input
            type="number"
            placeholder="Enter Amount"
            value={topUpAmount}
            onChange={handleAmountChange}
            className="mb-4 w-3/4 p-2 border rounded"
          />
          <Button className="bg-blue-500 text-white px-4 py-2 rounded" onClick={handleTopUp}>
            Add Money
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default Wallet;
